import { render, staticRenderFns } from "./home.vue?vue&type=template&id=6d08c2a9&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("../../assets/css/leftnavChat.css?vue&type=style&index=0&id=6d08c2a9&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6d08c2a9",
  "e7d9ee5a"
  
)

export default component.exports